import { useEffect, useState } from 'react';
import { NextRouter } from 'next/router';

const useRouteChangeLoading = (router: NextRouter | null): boolean => {
  const [routeLoading, setRouteLoading] = useState(false);

  useEffect(() => {
    const handleStart = () => setRouteLoading(true);
    const handleComplete = () => setRouteLoading(false);

    router?.events.on('routeChangeStart', handleStart);
    router?.events.on('routeChangeComplete', handleComplete);
    router?.events.on('routeChangeError', handleComplete);

    return () => {
      router?.events.off('routeChangeStart', handleStart);
      router?.events.off('routeChangeComplete', handleComplete);
      router?.events.off('routeChangeError', handleComplete);
    };
  }, [router]);

  return routeLoading;
};

export default useRouteChangeLoading;
